import React, { useState, useEffect } from "react";

import bannerImg from "../banner/banneri.png";
import {
  conferenceInfo,
  carouselImages,
  notices,
  convenor,
  coConvenors,
  contactInfo,
} from "../data/mockData";
import { ChevronLeft, ChevronRight, Download } from "lucide-react";

const partnerLogos = [
  "/images/logos/logo1.jpg",
  "/images/logos/logo2.jpg",
  "/images/logos/logo3.jpg",
  "/images/logos/logo4.jpg",
  "/images/logos/logo5.jpg",
  "/images/logos/logo6.jpg",
];

const carouselCaptions = [
  {
    index: 1,
    subtitle: "Integral University",
    title: "Full Campus View",
  },
  {
    index: 2,
    subtitle: "Integral University",
    title: "Department of Civil Engineering",
  },
  {
    index: 3,
    subtitle: "Integral University",
    title: "Central Auditorium",
  },
  {
    index: 4,
    subtitle: "Integral University",
    title: "Academic Block I",
  },
  {
    index: 5,
    subtitle: "Integral University",
    title: "Phase III",
  },
  {
    index: 6,
    subtitle: "Integral University",
    title: "University Ground",
  },
  {
    index: 7,
    subtitle: "Integral University",
    title: "Boys Hostel",
  },
  {
    index: 8,
    subtitle: "Integral University",
    title: "Block A, Phase III",
  },
];

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () =>
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);

  const prevSlide = () =>
    setCurrentSlide(
      (prev) => (prev - 1 + carouselImages.length) % carouselImages.length,
    );

  const handleNoticeClick = (pdfUrl) => window.open(pdfUrl, "_blank");

  return (
    <div className="-mt-5">
      <div className="bg-gradient-to-r from-slate-500 via-white to-slate-600 border-b border-gray-200 py-5">
        <p className="text-center text-xl font-bold tracking-widest text-black mb-4">
          OUR PARTNERS
        </p>

        <div className="max-w-6xl mx-auto px-2 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-10 items-center justify-items-center">
          {partnerLogos.map((logo, i) => (
            <img
              key={i}
              src={logo}
              alt="partner"
              className="h-20 object-contain hover:scale-110 transition duration-300"
            />
          ))}
        </div>
      </div>
      {/* HERO */}
      <div
        className="relative min-h-screen bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: `url(${bannerImg})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/70 to-black/80" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.25),transparent_40%),radial-gradient(circle_at_80%_30%,rgba(59,130,246,0.35),transparent_40%)]"></div>

        <div className="relative z-10 text-center max-w-5xl mx-auto px-3">
          <span className="inline-block px-6 py-2 bg-white/25 backdrop-blur-md rounded-full text-white font-semibold tracking-widest mb-4 shadow-lg">
            TG-SMART 2026
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-14 drop-shadow-[0_4px_12px_rgba(0,0,0,0.9)]">
            {conferenceInfo.title}
          </h1>

          <div className="bg-black/1 backdrop-blur-md border border-white/20 rounded-3xl px-4 py-10 shadow-2xl">
            <h2 className="text-lg md:text-xl text-gray-100 mb-4 font-medium drop-shadow-md">
              {conferenceInfo.subtitle}
            </h2>

            <h3 className="text-2xl md:text-4xl font-bold text-red-400 my-6 drop-shadow-lg">
              {conferenceInfo.shortName}
            </h3>

            <p className="text-xl font-semibold text-white mb-3 drop-shadow-md">
              {conferenceInfo.dates}
            </p>
          </div>
        </div>
      </div>
      {/* CAROUSEL */}
      {/*CAMPUS GALLERY*/}
      <div id="gallery" className="py-15 bg-slate-50 relative overflow-hidden">
        {/* subtle pattern background */}
        <div
          className="absolute inset-0 opacity-[0.25] 
     bg-[radial-gradient(#94a3b8_1px,transparent_1px)] bg-[size:24px_24px]"
        ></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6"></div>
        <div
          id="gallery"
          className="bg-[radial-gradient(circle_at_15%_25%,rgba(59,130,246,0.22),transparent_32%),radial-gradient(circle_at_85%_20%,rgba(167,139,250,0.18),transparent_32%),radial-gradient(circle_at_50%_80%,rgba(134,239,172,0.18),transparent_35%)] py-16"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-800 mb-2">
              Campus Gallery
            </h2>
            <div className="w-32 h-1 bg-primary-600 mx-auto mb-10"></div>

            {/* MAIN SLIDER */}
            <div className="relative h-[300px] sm:h-[520px] overflow-hidden mb-2 rounded-3xl shadow-[0_25px_80px_rgba(0,0,0,0.25)] group">
              {/* Slides */}
              {carouselImages.map((image, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-all duration-1000 ${
                    index === currentSlide
                      ? "opacity-100 scale-100"
                      : "opacity-0 scale-110"
                  }`}
                >
                  <img
                    src={image}
                    alt={`Campus ${index + 1}`}
                    className="w-full h-full object-cover"
                  />

                  {/* Gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                  {/* Caption */}
                  <div className="absolute bottom-10 left-10 text-white">
                    <p className="text-sm uppercase tracking-widest opacity-80">
                      {carouselCaptions[index]?.subtitle ||
                        "Integral University"}
                    </p>

                    <h3 className="text-2xl md:text-4xl font-bold">
                      {carouselCaptions[index]?.title ||
                        `Campus View ${index + 1}`}
                    </h3>
                  </div>
                </div>
              ))}

              {/* LEFT BUTTON */}
              <button
                onClick={prevSlide}
                className="absolute left-6 top-1/2 -translate-y-1/2 z-20 bg-white/20 backdrop-blur-md hover:bg-white text-white hover:text-black p-4 rounded-full shadow-xl opacity-0 group-hover:opacity-100 transition"
              >
                <ChevronLeft size={32} />
              </button>

              {/* RIGHT BUTTON */}
              <button
                onClick={nextSlide}
                className="absolute right-6 top-1/2 -translate-y-1/2 z-20 bg-white/20 backdrop-blur-md hover:bg-white text-white hover:text-black p-4 rounded-full shadow-xl opacity-0 group-hover:opacity-100 transition"
              >
                <ChevronRight size={32} />
              </button>

              {/* DOT INDICATORS */}
              <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-3">
                {carouselImages.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`transition-all duration-300 ${
                      index === currentSlide
                        ? "w-10 h-3 bg-white rounded-full"
                        : "w-3 h-3 bg-white/60 rounded-full hover:bg-white"
                    }`}
                  />
                ))}
              </div>
            </div>

            {/* THUMBNAIL STRIP */}
            <div className="flex gap-4 mt-6 overflow-x-auto pb-2 justify-center">
              {carouselImages.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  onClick={() => setCurrentSlide(index)}
                  className={`h-20 w-32 object-cover rounded-xl cursor-pointer transition-all duration-300 ${
                    currentSlide === index
                      ? "ring-4 ring-primary-600 scale-105"
                      : "opacity-60 hover:opacity-100"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/*MAP + NOTICES*/}
      <section className="relative py-20 overflow-hidden">
        {/* blended background */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100"></div>

        {/* floating color blobs */}
        <div className="absolute top-[-120px] left-[-120px] w-[420px] h-[420px] bg-primary-300 rounded-full blur-[140px] opacity-30"></div>
        <div className="absolute bottom-[-120px] right-[-120px] w-[420px] h-[420px] bg-indigo-300 rounded-full blur-[140px] opacity-30"></div>
        <div className="absolute top-[40%] left-[40%] w-[320px] h-[320px] bg-sky-200 rounded-full blur-[120px] opacity-30"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          {/* Section Heading */}
          <div className="text-center mb-5">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-800">
              Venue & Announcements
            </h2>
            <div className="w-32 h-1 bg-primary-600 mx-auto mt-4"></div>
            <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
              Find us on the map and stay updated with the latest conference
              notices.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-start">
            {/*MAP CARD*/}
            <div className="lg:col-span-3 group">
              <div className="bg-white/70 backdrop-blur-lg rounded-3xl shadow-[0_20px_70px_rgba(0,0,0,0.15)] border border-white p-6 transition-all duration-500 group-hover:shadow-[0_25px_90px_rgba(0,0,0,0.25)]">
                <h3 className="text-2xl font-bold text-gray-800 mb-2">
                  Venue Location
                </h3>
                <div className="w-20 h-1 bg-primary-600 mb-6"></div>

                <div className="rounded-2xl overflow-hidden border-4 border-white shadow-xl">
                  <iframe
                    title="Integral University Location"
                    src={contactInfo.mapUrl}
                    width="100%"
                    height="420"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                  ></iframe>
                </div>

                <p className="text-sm text-gray-600 mt-4">
                  Integral University, Lucknow — Conference Venue
                </p>
              </div>
            </div>

            {/*NOTICES CARD*/}
            <div className="lg:col-span-2 group">
              <div className="bg-white/70 backdrop-blur-lg rounded-3xl shadow-[0_20px_70px_rgba(0,0,0,0.15)] border border-white p-6 h-[520px] overflow-hidden relative transition-all duration-500 group-hover:shadow-[0_25px_90px_rgba(0,0,0,0.25)]">
                <h3 className="text-2xl font-bold text-gray-800 mb-2">
                  Latest Notices
                </h3>
                <div className="w-20 h-1 bg-primary-600 mb-6"></div>

                <div className="absolute inset-x-6 top-24 bottom-6 overflow-hidden">
                  <div className="animate-scroll space-y-4">
                    {[...notices].map((notice, index) => (
                      <div
                        key={index}
                        onClick={() => handleNoticeClick(notice.pdfUrl)}
                        className="bg-gradient-to-r from-primary-100 to-indigo-100 p-4 rounded-xl shadow-md hover:shadow-xl transition-all cursor-pointer border-l-4 border-primary-600 group"
                      >
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <p className="text-xs text-primary-700 font-semibold mb-1">
                              {notice.date}
                            </p>
                            <p className="text-sm text-gray-700 group-hover:text-primary-800">
                              {notice.text}
                            </p>
                          </div>

                          <Download
                            size={18}
                            className="text-primary-600 flex-shrink-0 ml-3 group-hover:scale-110 transition-transform"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Message from Convenor */}
      <div className="bg-[radial-gradient(circle_at_15%_25%,rgba(59,130,246,0.22),transparent_32%),radial-gradient(circle_at_85%_20%,rgba(167,139,250,0.18),transparent_32%),radial-gradient(circle_at_50%_80%,rgba(134,239,172,0.18),transparent_35%)] py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-800 mb-2">
            Message from the Convenor
          </h2>
          <div className="w-32 h-1 bg-primary-600 mx-auto mb-8"></div>
          <div className="bg-primary-100 rounded-xl shadow-2xl p-8 border-t-4 border-primary-600">
            <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
              {/* Image clickable */}
              <a
                href={convenor.linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={convenor.image}
                  alt={convenor.name}
                  className="w-60 h-60 rounded-full object-cover border-4 border-primary-600 shadow-xl hover:scale-105 transition-transform"
                />
              </a>

              <div className="flex-1 text-center md:text-left">
                {/* Name clickable */}
                <a
                  href={convenor.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-2xl font-bold text-gray-800 mb-2 hover:text-primary-700 hover:underline transition-colors"
                >
                  {convenor.name}
                </a>

                <p className="text-primary-700 font-semibold mb-1">
                  {convenor.designation}
                </p>
                <p className="text-gray-600 mb-4">{convenor.organization}</p>
                <p className="text-gray-700 leading-relaxed italic text-base">
                  &ldquo;{convenor.message}&rdquo;
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Messages from Co-Convenors */}
      <div className="bg-primary-100 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-800 mb-2">
            Messages from Co-Convenors
          </h2>
          <div className="w-32 h-1 bg-primary-600 mx-auto mb-8"></div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {coConvenors.map((coConvenor) => (
              <div
                key={coConvenor.id}
                className="bg-white rounded-xl shadow-xl p-6 border-t-4 border-primary-600 hover:shadow-2xl transition-shadow"
              >
                <a
                  href={coConvenor.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <img
                    src={coConvenor.image}
                    alt={coConvenor.name}
                    className="w-32 h-32 rounded-full object-cover border-4 border-primary-500 shadow-lg mx-auto mb-4 hover:scale-105 transition-transform"
                  />
                </a>

                <a
                  href={coConvenor.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xl font-bold text-gray-800 mb-2 text-center block hover:text-primary-700 hover:underline transition-colors"
                >
                  {coConvenor.name}
                </a>
                <p className="text-primary-700 font-semibold text-sm mb-1 text-center">
                  {coConvenor.designation}
                </p>
                <p className="text-gray-600 text-sm mb-4 text-center">
                  {coConvenor.organization}
                </p>
                <p className="text-gray-700 text-sm leading-relaxed italic text-center">
                  &ldquo;{coConvenor.message}&rdquo;
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
